import React from 'react';
import classNames from 'classnames';
import classes from './IconButton.scss';

interface IProps {
    onClick(): void;
    className?: string;
    active?: boolean;
    disabled?: boolean;
    children: React.ReactElement;
    dataQa?: string;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IProps>((props, ref) => (
    <button
        ref={ref}
        type="button"
        onClick={props.onClick}
        disabled={props.disabled}
        className={classNames(classes.button, props.className, {
            [classes.active]: props.active,
            [classes.disabled]: props.disabled,
        })}
        data-qa={props.dataQa}
    >
        {React.cloneElement(React.Children.only(props.children), {
            className: classNames(classes.icon, props.children.props.className),
        })}
    </button>
));
